var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons - Outline/Status indicators/error-circle/4px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,6.725 C58.3726727,6.725 73.2666667,21.618994 73.2666667,39.9916667 C73.2666667,58.3643393 58.3726727,73.2583333 40,73.2583333 C21.6273273,73.2583333 6.73333333,58.3643393 6.73333333,39.9916667 C6.73333333,21.618994 21.6273273,6.725 40,6.725 Z M40,9.925 C23.3946385,9.925 9.93333333,23.3863052 9.93333333,39.9916667 C9.93333333,56.5970281 23.3946385,70.0583333 40,70.0583333 C56.6053615,70.0583333 70.0666667,56.5970281 70.0666667,39.9916667 C70.0666667,23.3863052 56.6053615,9.925 40,9.925 Z M53.6104652,28.4686292 C54.235304,27.8437903 55.248368,27.8437903 55.8732069,28.4686292 C56.4980457,29.093468 56.4980457,30.106532 55.8732069,30.7313708 L55.8732069,30.7313708 L35.1440405,51.4605372 C34.5192016,52.0853761 33.5061376,52.0853761 32.8812988,51.4605372 L32.8812988,51.4605372 L23.6686292,42.2478676 C23.0437903,41.6230288 23.0437903,40.6099648 23.6686292,39.9851259 C24.293468,39.3602871 25.306532,39.3602871 25.9313708,39.9851259 L25.9313708,39.9851259 L34.0126696,48.0664247 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DID-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registration_Username_email_Success",
    transform: "translate(-154.000000, -85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/success-circle/4px-colour-mask",
    transform: "translate(148.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#333333",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colours/Green-2-|-#428600",
    mask: "url(#mask-2)",
    fill: "#428600",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.b297432fec847ebcde2d51664ba93942.svg";
export { ForwardRef as ReactComponent };